import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class JobsDomainRedirectGuard implements CanActivate {
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const currentHost = window.location.hostname;
        const bookingDomains = ['booking-test.classcover.com.au', 'booking.classcover.com.au'];
        const jobsDomains = ['jobs-test.classcover.com.au', 'jobs.classcover.com.au'];
        // If on any booking domain, redirect to jobs-test (prefer jobs-test, fallback to jobs)
        if (bookingDomains.includes(currentHost)) {
            const protocol = window.location.protocol;
            // Prefer jobs-test, fallback to jobs
            const jobsTarget = jobsDomains[0];
            const path = state.url;
            const newUrl = `${protocol}//${jobsTarget}${path}`;
            window.location.href = newUrl;
            return false;
        }
        return true;
    }
}
